<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <card>
                        <template slot="header">
                            <h4 class="card-title">Отчеты</h4>

                            <div class="row mt10">
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label for="is-premium-filter" class="control-label">Начальная дата</label>
                                        <select v-model="dateStart" id="date-start-filter"
                                                aria-describedby="addon-right addon-left" class="form-control">
                                            <option v-for="d in dates_start" v-bind:value="d">{{ d | toEasyDate }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label for="is-premium-filter" class="control-label">Конечная дата</label>
                                        <select v-model="dateEnd" id="date-start-filter"
                                                aria-describedby="addon-right addon-left" class="form-control">
                                            <option v-for="d in dates_end" v-bind:value="d">{{ d | toEasyDate }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-1">
                                    <button type="submit" class="btn btn-info btn-fill"
                                            @click.prevent="filter">
                                        Фильтровать
                                    </button>
                                </div>
                                <div class="col-md-5">
                                </div>
                                <div class="col-md-2">
                                    <button type="submit" class="btn btn-success btn-fill float-right"
                                            @click.prevent="add">
                                        Загрузить отчет
                                    </button>
                                </div>
                                <!--<div class="col-md-6">-->
                                <!--<button type="submit" class="btn btn-success btn-fill float-right"-->
                                <!--@click.prevent="add">-->
                                <!--Add wallpaper-->
                                <!--</button>-->
                                <!--</div>-->
                            </div>
                        </template>
                        <div class="table-responsive">
                            <table class="table" v-bind:class="{ 'loading-state': loading }">
                                <thead>
                                <slot name="columns">
                                    <th v-for="column in columns">
                                        <span v-if="column === 'period'">Период</span>
                                        <span v-else-if="column === 'my_feed'">My Feed, $</span>
                                        <span v-else-if="column === 'muse'">Muse, $</span>
                                        <span v-else-if="column === 'wallpapers'">Wallpapers, $</span>
                                        <span v-else-if="column === 'imagine'">Imagine, $</span>
                                        <span v-else-if="column === 'framy'">Framy, $</span>
                                        <span v-else-if="column === 'marketing_spend'">Расходы (Маркетинг, команда), $</span>
                                        <span v-else-if="column === 'summary'">Всего, $</span>
                                        <span v-else></span>
                                    </th>
                                </slot>
                                </thead>
                                <tbody>
                                <tr v-for="item in data">
                                    <td>{{ item.date_start | toEasyDate }} - {{ item.date_end | toEasyDate }}</td>
                                    <td>{{  item.info[0] | toMoneyFormat }}</td>
                                    <td>{{  item.info[1] | toMoneyFormat }}</td>
                                    <td>{{  item.info[2] | toMoneyFormat }}</td>
                                    <td>{{  item.info[3] | toMoneyFormat }}</td>
                                    <td>{{  item.info[4] | toMoneyFormat }}</td>
                                    <td>{{  item.marketing_spend | toMoneyFormat }} ({{  item.other_spend | toMoneyFormat }})</td>
                                    <td>{{  item.summary | toMoneyFormat }}</td>
                                    <td>
<!--                                        <a class="text-primary" @click="edit(item['id'])">Изменить</a>-->
                                    </td>
                                </tr>
                                <tr v-if="summary" class="summary">
                                    <td><span v-if="data.length > 0">{{ data[0].date_start | toEasyDate }} - {{ data[data.length - 1].date_end | toEasyDate }}</span></td>
                                    <td>{{  summary[0] | toMoneyFormat }}</td>
                                    <td>{{  summary[1] | toMoneyFormat }}</td>
                                    <td>{{  summary[2] | toMoneyFormat }}</td>
                                    <td>{{  summary[3] | toMoneyFormat }}</td>
                                    <td>{{  summary[4] | toMoneyFormat }}</td>
                                    <td>0 (0)</td>
                                    <td>{{  summary[5] | toMoneyFormat }}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </card>

                </div>

            </div>
        </div>
    </div>
</template>
<script>
const axios = require('axios')
const moment = require('moment')
import LTable from 'src/components/UIComponents/Table.vue'
import Card from 'src/components/UIComponents/Cards/Card.vue'

export default {
    components: {
        LTable,
        Card
    },
    data() {
        return {
            columns: ['period', 'my_feed', 'muse', 'wallpapers', 'imagine', 'framy', 'marketing_spend', 'summary', ''],
            data: [],
            summary: [],
            dateStart: '',
            dateEnd: '',
            type: "",
            dates_start: localStorage.getItem('r_dates_start') ? JSON.parse(localStorage.getItem('r_dates_start')) : [],
            dates_end: localStorage.getItem('r_dates_end') ? JSON.parse(localStorage.getItem('r_dates_end')) : [],
            loading: false
        }
    },
    filters: {
        toEasyDate (value) {
            if (value) {
                return moment(String(value)).format('DD.MM.YYYY')
            } else {
                return '';
            }
        },
        toMoneyFormat (value) {
            if (value) {
                return Intl.NumberFormat().format(value)
            } else {
                return '';
            }
        },
    },
    created: function () {
        this.get();
    },
    methods: {
        filter: function () {
            this.get();
        },
        add: function () {
            this.$router.push('/reports/create');
        },
        edit: function (id) {
            this.$router.push({
                name: 'edit-report',
                params: {id: id}
            });
        },
        get: function () {
            let self = this;

            let token = localStorage.getItem('token');

            let dateStart = this.dateStart === null ? '' : this.dateStart;
            let dateEnd = this.dateEnd === null ? '' : this.dateEnd;

            this.loading = true;

            axios.get(
                `${this.$hostname}/admin/reports/`,
                {
                    'params': {
                        date_start: dateStart,
                        date_end: dateEnd,
                    },
                    'headers': {
                        'Authorization': 'Bearer ' + token
                    }
                })
                .then(function (response) {
                    self.loading = false;
                    self.data = response.data.reports;
                    self.summary = response.data.sumArray;


                    let reversed = _.reverse(self.data)
                    if (self.dates_start.length < 1) {
                        _.map(reversed, (d) => {
                            self.dates_start.push(d.date_start)
                        })
                        localStorage.setItem('r_dates_start', JSON.stringify(self.dates_start));
                    }
                    if (self.dates_end.length < 1) {
                        _.map(reversed, (d) => {
                            self.dates_end.push(d.date_end)
                        })
                        localStorage.setItem('r_dates_end', JSON.stringify(self.dates_end));
                    }
                })
                .catch(function (error) {
                    self.loading = false;
                    console.log(error)
                })
        },
    },
    beforeRouteLeave (to, from , next) {
        localStorage.setItem('r_dates_start', []);
        localStorage.setItem('r_dates_end', []);
        next();
    },
}
</script>
<style scoped>

.mt10 {
    margin-top: 10px;
}

.btn-fill {
    margin-top: 25px;
}
.text-primary {
    cursor: pointer;
}
th {
    padding: 12px 8px;
}
.loader {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    background-color: #eceaea;
    background-image: url('/static/img/oval.svg');
    background-size: 50px;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 10000000;
    opacity: 0.7;
    filter: alpha(opacity=40);
}
.summary td, .summary span {
    font-weight: 700 !important;
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports.vue